import React from 'react'
import { Route, Redirect, Switch as RouterSwitch } from 'react-router-dom'
import { useKeycloak } from 'component/base'

export const PublicRoute = ({ component: Component, ...rest }) => {
  const { keycloak } = useKeycloak()

  return (
    <Route
      {...rest}
      render={props => <Component {...props} keycloak={keycloak} />}
    />
  )
}

export const SecretRoute = ({ component: Component, ...rest }) => {
  const { keycloak } = useKeycloak()

  return (
    <Route
      {...rest}
      render={props =>
        keycloak.authenticated ? (
          <Component {...props} keycloak={keycloak} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

export const Switch = props => {
  const { children, ...other } = props

  return (
    <RouterSwitch {...other}>
      {children}
      <Redirect to='/error/404' />
    </RouterSwitch>
  )
}
